// extracted by mini-css-extract-plugin
export const faqSection = "faq-module--faqSection--22jUv";
export const faq = "faq-module--faq--1rsmi";
export const question = "faq-module--question--24iXC";
export const answer = "faq-module--answer--1s2bS";
export const hide = "faq-module--hide--1MQ5G";
export const icon = "faq-module--icon--2RwCr";